export const FEEDBACK_MESSAGES = {
  LOGIN_SUCCESS:
    "You're all set! Your account is secure, and you can now explore GCX",
  CHECKOUT_FLOW_SUCCESS:
    "You're all set! Your account is secure, and you can now continue with your checkout."
};
